/**
 * Auth token storage utility
 * Backward compatibility layer - now uses Zustand store
 * All existing code using these functions will continue to work
 */

import { 
  getAuthToken as storeGetAuthToken,
  setAuthToken as storeSetAuthToken,
  removeAuthToken as storeRemoveAuthToken,
  hasAuthToken as storeHasAuthToken,
  getAuthHeaders as storeGetAuthHeaders,
} from "@/stores/authStore";

/**
 * Store authentication token
 * @deprecated Use useAuthStore().setToken() directly for new code
 */
export function setAuthToken(token: string): void {
  storeSetAuthToken(token);
}

/**
 * Get authentication token
 * @deprecated Use useAuthStore().getAuthToken() directly for new code
 */
export function getAuthToken(): string | null {
  return storeGetAuthToken();
}

/**
 * Remove authentication token
 * @deprecated Use useAuthStore().clearAuth() directly for new code
 */
export function removeAuthToken(): void {
  storeRemoveAuthToken();
}

/**
 * Check if user has a token
 * @deprecated Use useAuthStore().hasAuthToken() directly for new code
 */
export function hasAuthToken(): boolean {
  return storeHasAuthToken();
}

/**
 * Get headers with Authorization token if available
 * @deprecated Use useAuthStore().getAuthHeaders() directly for new code
 */
export function getAuthHeaders(): Record<string, string> {
  return storeGetAuthHeaders();
}

